var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 3,
    fill: "#F6FAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4154 11.25C17.8094 11.25 19.7504 13.1527 19.7504 15.5C19.7504 17.8473 17.8094 19.75 15.4154 19.75C14.3053 19.75 13.2925 19.3407 12.5254 18.6679",
    stroke: "#A6C6F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7C20.1946 7 24 10.8054 24 15.5C24 20.1945 20.1946 24 15.5 24C13.2895 24.003 11.1654 23.1418 9.58103 21.6004C8.76324 20.809 8.11323 19.8609 7.66979 18.8128C7.22635 17.7647 6.99856 16.638 7.00001 15.5C6.99712 13.3087 7.84347 11.2015 9.36131 9.62097",
    stroke: "#A6C6F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35938 9.62109L15.4981 15.5001L9.5791 21.6006",
    stroke: "#A6C6F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic1);
export default __webpack_public_path__ + "static/media/topic1.4bb1e8cd0fc2208b04666c10058ca0d9.svg";
export { ForwardRef as ReactComponent };